import Types from "./Types";

const INITIAL_STATE = {
  studentPerGroup: [],
  performance: {},
  videosReport: [],
  homeworkUncomment: [],
  attendancesReport: [],
  examReport: [],
  unpaidReport: [],
  paidReport: [],
  examAttendance: [],
  homeworkAttendance: [],
  homeworkAbsent: [],
  savedMessages: [],
  isLoading: false,
};

export default function reports(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.STUDENTS_PER_GROUP_SUCCESS: {
      return {
        ...state,
        studentPerGroup: payload.data,
      };
    }

    case Types.VIDEO_REPORT_SUCCESS: {
      return {
        ...state,
        videosReport: payload.data,
      };
    }

    case Types.UNPAID_REPORT_SUCCESS: {
      return {
        ...state,
        unpaidReport: payload.data.data,
      };
    }
    case Types.PAID_REPORT_SUCCESS: {
      return {
        ...state,
        paidReport: payload.data.data,
      };
    }
    case Types.ATTENDANCE_REPORT_SUCCESS: {
      return {
        ...state,
        attendancesReport: payload.data.data,
      };
    }

    // create
    case Types.EXAM_REPORT_SUCCESS: {
      return {
        ...state,
        examReport: payload.data?.data,
      };
    }
    case Types.EXAM_ATTENDANCE_SUCCESS: {
      return {
        ...state,
        examAttendance: payload.data,
      };
    }

    case Types.HOMEWORK_ATTENDENCE_REPORT_SUCCESS: {
      return {
        ...state,
        homeworkAttendance: payload.data?.data,
      };
    }
    case Types.HOMEWORK_UNCOMMENT_REPORT_SUCCESS: {
      return {
        ...state,
        homeworkUncomment: payload.data?.data,
      };
    }
    case Types.FILTER_HOMEWORK_ATTENDENCE_REPORT_SUCCESS: {
      return {
        ...state,
        homeworkAttendance: payload.data?.data,
      };
    }
    case Types.HOMEWORK_ABSENT_REPORT_SUCCESS: {
      return {
        ...state,
        homeworkAbsent: payload.data,
      };
    }

    case Types.DELETE_STUDENT_HOMEWORK_SUCCESS: {
      //console.log(payload);
      const newhomeworks = state.homeworkUncomment.filter(
        (item) => item.student_id !== payload.student_id
      );
      return {
        ...state,
        homeworkUncomment: newhomeworks,
      };
    }
    case Types.RESTRICT_STUDENT_HOMEWORK_REQUEST: {
      return {
        ...state,
      };
    }
    case Types.ACCEPT_STUDENT_HOMEWORK_SUCCESS: {
      return {
        ...state,
      };
    }
    case Types.COMMENT_STUDENT_HOMEWORK_SUCCESS: {
      const newhomeworks = state.homeworkUncomment.filter(
        (item) => item.id !== payload
      );
      return {
        ...state,
        homeworkUncomment: newhomeworks,
      };
    }
    case Types.STUDENT_PERFORMANCE_SUCCESS: {
      return {
        ...state,
        performance: payload.data,
      };
    }

    case Types.REPORT_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    case Types.CENTER_HW_SUCCESS: {
      return {
        ...state,
        centerHw: payload.data,
      };
    }

    case Types.VIDEO_ABSENCE_REPORT_SUCCESS: {
      return {
       ...state,
        videosReport: payload,
      };
    }

    case Types.VIDEO_ABSENCE_REPORT_LOADING: {
      return {
      ...state,
        isLoading: payload,
      };
    }

    case Types.MONTHLY_REPORT_SUCCESS: {
      return {
        ...state,
        monthlyReport: payload,
      };
    }

    case Types.SEND_BULK_CUSTOM_MESSAGE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.SEND_BULK_CUSTOM_MESSAGE_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.GET_SAVED_MESSAGES_BY_INTERVAL_SUCCESS: {
      return {
        ...state,
        savedMessages: payload.data?.data || payload.data || [],
      };
    }

    case Types.SEND_SAVED_MESSAGES_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.SEND_SAVED_MESSAGES_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.NOTIFY_PARENT_FOR_EXAM_ABSENCE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.NOTIFY_PARENT_FOR_EXAM_ABSENCE_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    default: {
      return state;
    }
  }
}
